<template>
    <div>
        <v-chip color="purple" outlined small label
            style="position: fixed; top: 70px; right: 16px; z-index: 1000;">
            <v-icon left small>mdi-file-code-outline</v-icon>
            FormSubsidioNacimiento.vue
        </v-chip>
        <DialogoComDistrito ref="dialogoCom" />
        <v-overlay :value="loading">
            <v-container fill-height fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="d-flex row justify-center align-center">
                        <v-img src="@/assets/Logo-bt-06.png" width="480" class="animacion-logo"></v-img>
                    </v-col>
                    <v-progress-circular indeterminate size="84" width="8" color="white"
                        class="animacion-process ma-5"></v-progress-circular>
                </v-row>
            </v-container>
        </v-overlay>
        <ValidationObserver ref="obs" v-slot="{ invalid, handleSubmit }">
            <v-form name="formSubsidioNacimiento" v-model="valid" @submit.prevent="handleSubmit(iniciarTramite)">
                <v-card class="custom-card" flat>
                    <v-card-text class="ma-0 pa-0">
                        <v-alert v-if="mostrarMensaje" colored-border color="orange darken-3" border="left"
                            elevation="0" dense
                            class="rounded-0 font-weight-regular text-body-1 orange--text text--darken-3">
                            {{ (necesitaNota) ? mensajeNota : mensajeSubsidio }}
                        </v-alert>
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text">
                                INFORMACIÓN SOBRE HIJO/A
                            </v-card-text>
                        </v-row>
                        <ValidationObserver ref="datosBasicosObserver" v-slot="{ validate, valid }">
                            <v-row class="d-flex flex-column" v-if="familiaresSubsidios.length !== 0">
                                <ValidationProvider v-slot="v">
                                    <v-col class="mt-2">
                                        <v-select clearable :items="familiaresSubsidios" v-model="familiarSeleccionado"
                                            return-object chips deletable-chips multiple
                                            :item-text="item => `${item.nombres} ${item.apellido} | DNI: ${item.nrodoc}`"
                                            label="Seleccionar familiar" @change="capturarFamiliares"></v-select>
                                    </v-col>
                                </ValidationProvider>
                            </v-row>
                            <v-row class="mt-5">
                                <v-col>
                                    <ValidationProvider rules="required|menordosanios" v-slot="v">
                                        <v-text-field v-model="afiliado.pnc_fechaNac" :disabled="(infoFamiliar)" dense
                                            label="Fecha de nacimiento:" type="date"
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row v-for="(hijo, index) in familiar" :key="index">
                                <v-col v-if="index > 0" cols="12" md="12">
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="10" md="10" class="my-2">
                                    <div class="font-weight-bold text-body-2 primary--text">
                                        HIJO/A {{ index + 1 }}
                                    </div>
                                </v-col>
                                <v-col class="d-flex justify-end align-end" v-if="index > 0">
                                    <v-btn fab small @click="eliminarHijo(index)" color="error" outlined>
                                        <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                        <v-text-field dense v-model="hijo.pnh_nombre" label="Nombres"
                                            :error-messages="v.errors[0]" :disabled="(infoFamiliar)"
                                            @input="hijo.pnh_nombre = hijo.pnh_nombre.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                        <v-text-field dense v-model="hijo.pnh_apellido" type="text" label="Apellido"
                                            :error-messages="v.errors[0]" :disabled="(infoFamiliar)"
                                            @input="hijo.pnh_apellido = hijo.pnh_apellido.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="8" md="6">
                                    <ValidationProvider rules="required|minmax:7,8|numeric" v-slot="v">
                                        <v-text-field dense v-model="hijo.pnh_nroDoc" type="number" hide-spin-buttons
                                            @input="hijo.pnh_nroDoc = hijo.pnh_nroDoc" label="Nro. DNI"
                                            :disabled="(infoFamiliar)" :error-messages="v.errors[0]"
                                            @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="4" md="6">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select dense v-model="hijo.pnh_sexo" :items="itemSexo" label="Sexo"
                                            :error-messages="v.errors[0]" :disabled="(infoFamiliar)">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-autocomplete dense v-model="familiarOriginal[index].nacionalidad"
                                            @input="selectNacionalidad($event, index)" return-object
                                            :items="nacionalidades" item-value="id" item-text="desnacionalidad"
                                            label="Nacionalidad" :disabled="(infoFamiliar)"
                                            :error-messages="v.errors[0]">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select dense v-model="familiarOriginal[index].tipnacionalidad"
                                            :error-messages="v.errors[0]" @input="selectTipNacionalidad($event, index)"
                                            :disabled="(infoFamiliar)" :items="tipoNacionalidad" item-value="tna_id"
                                            return-object item-text="tna_destipnac" label="Tipo de nacionalidad">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select v-model="afiliado.pnc_hijoFall" :items="hijoFallOptions"
                                            :disabled="(infoFamiliar)" item-text="text" item-value="value"
                                            label="Hijo Fallecido" dense></v-select>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn @click="addHijo" :disabled="(infoFamiliar)" small :loading="loading"
                                        color="primary lighten-1" class="pa-5" rounded>
                                        <v-icon class='mr-2'>mdi-account-plus-outline</v-icon>
                                        AGREGAR HIJO/A
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" class="d-flex justify-end">
                                    <v-btn v-if="infoFamiliar" color="primary" elevation="0" class="pa-5"
                                        :loading="loadBtn" @click="habilitarInformacionFam">
                                        <v-icon class="mr-2">mdi-refresh</v-icon>
                                        MODIFICAR INFORMACIÓN
                                    </v-btn>
                                    <v-btn v-else color="primary" elevation="0" class="pa-5" :loading="loadBtn"
                                        :disabled="!valid" @click="validarSubsidio">
                                        <v-icon class="mr-2">mdi-information</v-icon>
                                        VALIDAR INFORMACIÓN
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </ValidationObserver>
                        <v-row>
                            <v-col>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="d-flex flex-row justify-center align-center">
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                CUENTA DE ACREDITACIÓN
                            </v-card-text>
                        </v-row>
                        <ValidationObserver ref="datosCuentaObserver" v-slot="{ validate, valid }">
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-alert colored-border color="orange darken-3" border="left" elevation="0" dense
                                        class="rounded-0 font-weight-regular text-body-1 orange--text text--darken-3">
                                        Recordá que debés ser titular de la cuenta
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row v-if="mediosPagos.length !== 0">
                                <v-col cols="12" md="12">
                                    <v-select clearable chips deletable-chips v-model="medioSeleccionado"
                                        label="Seleccione cuenta" return-object
                                        :item-text="item => `CBU: ${item.deb_cbu1}${item.deb_cbu2}`"
                                        :items="mediosPagos" @change="capturarCuenta"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pnc_nomYApeTitular" type="text"
                                            hide-spin-buttons label="Titular" :error-messages="v.errors"
                                            :disabled="infoCuenta" @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required|length:22|numeric" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pnc_cbu" type="number" hide-spin-buttons
                                            label="CBU" :error-messages="v.errors" @keydown="preventArrowKeys"
                                            :disabled="infoCuenta">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required|length:11|numeric" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pnc_cuit" type="number" hide-spin-buttons
                                            :disabled="infoCuenta" label="CUIT/CUIL" :error-messages="v.errors"
                                            @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12" class="d-flex justify-end">
                                    <v-btn v-if="infoCuenta" color="primary" elevation="0" class="pa-5"
                                        :loading="loadBtn" @click="habilitarInfoCuenta">
                                        <v-icon class="mr-2">mdi-refresh</v-icon>
                                        MODIFICAR CUENTA
                                    </v-btn>
                                    <v-btn v-else color="primary" elevation="0" class="pa-5" :disabled="!valid"
                                        :loading="loadBtnCuenta" @click="validarCbu">
                                        <v-icon class="mr-2">mdi-information</v-icon>
                                        VALIDAR CUENTA
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </ValidationObserver>
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                DOCUMENTACIÓN REQUERIDA:
                            </v-card-text>
                        </v-row>
                        <v-row class="d-flex flex-row align-end justify-center">

                            <v-col v-for="(hijo, index) in familiar" :key="index" class="d-flex justify-center">

                                <InputButtonArchivo @fileSelected="handleFileSelected" op="partidaNacimiento"
                                    label="PARTIDA DE NACIMIENTO"
                                    :subtitle="hijo.pnh_nombre + ' ' + hijo.pnh_apellido" />
                            </v-col>
                            <v-col class="d-flex justify-center">
                                <InputButtonArchivo @fileSelected="handleFileSelected" :subtitle="nombreApellido"
                                    op="comprobanteCbu" label="COMPROBANTE DE CBU" />
                            </v-col>

                            <v-col cols="12" md="12" v-if="necesitaNota">
                                <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                                    <v-checkbox dense v-model="confirmarNota" :error-messages="v.errors[0]">
                                        <template v-slot:label>
                                            <div
                                                :class="(confirmarNota) ? `font-weight-regular primary--text` : `font-weight-regular black--text`">
                                                Al Directorio de la Caja: Solicito al Directorio que considere la
                                                solicitud del Subsidio por Maternidad, Art. 47 inc. b) de la Ley,
                                                teniendo en cuenta que se encuentra fuera de los plazos reglamentarios.
                                            </div>
                                        </template>
                                    </v-checkbox>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end align-center custom-card-actions-ha">
                        <v-btn color="primary" elevation="0" class="pa-5" :disabled="invalid || !formValid"
                            type="iniciarTramite">
                            <v-icon class="mr-2">mdi-send-outline</v-icon>
                            enviar trámite
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>

import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import DialogoComDistrito from '@/components/dialogos/DialogoComDistrito.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        InputButtonArchivo,
        DialogoComDistrito
    },
    watch: {
        'afiliado.pnc_fechaNac'(newDate) {
            this.familiar[0].pnh_fechaNac = newDate;
        },
        'afiliado.pnc_hijoFall'(newValue) {
            this.familiar[0].pnh_hijoFall = newValue;
        },
        mostrarMensaje(newVal) {
            // Si mostrarMensaje es true, cambia pnc_soloNacimiento a "N"
            if (newVal) {
                this.afiliado.pnc_soloNacimiento = "N";
            }
        },

    },
    mounted() {
        //this.afiliado.pad_remitirADistrito = this.user.distrito
        this.afiliado.pnc_nroafi = this.nroafi
        if (this.user.sexo == "F") this.tipoSubsidio = 'maternidadNacimiento'
        else this.tipoSubsidio = 'nacimiento'

        // this.afiliado.pnc_fechaNac = this.nroafi
        /*         this.afiliado.pad_cuit = this.user.cuil */
    },
    data() {
        return {
            loading: false,
            tipoSubsidio: '',
            mostrarMensaje: false,
            mensajeSubsidio: 'Se agregó automáticamente a tu solicitud el Subsidio por Maternidad, ya que cumplís con los requisitos para el mismo',
            mensajeNota: 'Si deseas agregar la solicitud para el Subsidio por Maternidad fuera del plazo de 45 días, recordá tildar la nota que se encuentra al pie de página',
            titulo: '',
            tipo: '',
            width: '',
            icon: '',
            itemSexo: ['F', 'M', 'X'], // item select sexo
            confirmarNota: false,


            /* Claves hijos
                'pnh_nombre',
                'pnh_apellido',
                'pnh_nroDoc',
                'pnh_tipodoc',
                'pnh_sexo',
                'pnh_fecaudit',
                'pnh_usuario',
                'pnh_fechaNac' 
            */
            familiar: [
                {
                    pnh_nombre: '',
                    pnh_apellido: '',
                    pnh_fechaNac: '',
                    pnh_nroDoc: '',
                    pnh_tipodoc: '1',
                    pnh_sexo: '',
                    pnh_fecaudit: '', //clave nueva
                }
            ],
            afiliado:
            {
                pnc_nroafi: "",
                pnc_fechaNac: "",
                //pad_fechaSentencia: "",
                pnc_nomYApeTitular: "",
                pnc_cbu: "",
                pnc_cuit: "",
                pnc_observaciones: "",

                pnc_hijoFall: "N",

                pnc_soloNacimiento: "S",
                /*
                    'pnc_nroafi',
                    'pnc_fechaSolicitud',
                    'pnc_cantHijos',
                    'pnc_fechaNac',
                    'pnc_apoderado',
                    'pnc_tipTitularCheque',
                    'pnc_titularCheque',
                    'pnc_metodoAcreditacion',
                    'pnc_propietarioCuenta',
                    'pnc_nomYApeTitular',
                    'pnc_cbu',
                    'pnc_cuit',
                    'pnc_cuentaCompartida',
                    'pnc_otroTitular',
                    'pnc_otroCuit',
                    'pnc_requisitos',
                    'pnc_remitirADistrito',
                    'pnc_soloNacimiento',
                    'pnc_hijoFall',
                    'pnc_observaciones',
                    'pnc_fecaudit',
                    'pnc_fecalta',
                    'pnc_usuario'
                */
            },
            familiarOriginal: [
                {
                    id: '',
                    nroafi: "",
                    nombres: "",
                    apellido: '',
                    sexo: "",
                    tipdoc: 1,
                    nrodoc: "",
                    estadocivil: '',
                    nacionalidad: '',
                    tipnacionalidad: '',
                    tipfamiliar: 3,
                    fecnacim: "",
                    fecfallecido: "",
                    fecestadocivil: "",
                    discapacidad: "",
                    accion: "A"
                }
            ],

            ordenClaves: ['id', 'nroafi', 'apellido', 'nombres', 'sexo', 'tipdoc', 'nrodoc', 'estadocivil', 'nacionalidad', 'tipnacionalidad', 'tipfamiliar', 'fecnacim', 'fecfallecido', 'fecestadocivil', 'discapacidad', 'accion'],
            formValid: false,
            familiarSeleccionado: null,
            medioSeleccionado: null,

            infoFamiliar: false,
            infoCuenta: false,

            loadBtn: false,
            loadBtnCuenta: false,

            hijoFallOptions: [
                { text: 'Si', value: 'S' },
                { text: 'No', value: 'N' },
            ]
        }
    },

    methods: {
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),
        ...mapActions('subsidios', ['solicitarSubsidiosNacimiento', 'solicitarSubsidiosMaternidadNacimiento', 'validarSubsidioAfiliado']),
        ...mapActions('mediosDePago', ['validarCBU']),

        habilitarInformacionFam() {
            this.infoFamiliar = false
            this.mostrarMensaje = false
        },
        habilitarInfoCuenta() {
            this.infoCuenta = false
        },
        selectNacionalidad(value, index) {
            this.$set(this.familiarOriginal, index, {
                ...this.familiarOriginal[index],
                nacionalidad: value.id,
                desnacionalidad: value.desnacionalidad
            });
        },
        selectTipNacionalidad(value, index) {
            this.$set(this.familiarOriginal, index, {
                ...this.familiarOriginal[index],
                tipnacionalidad: value.tna_id
            });
        },

        handleFileSelected() {
            (this.partidaNacimiento.every(element => element !== undefined && element !== null && element !== '') && (this.comprobanteCbu.length !== 0)) ? this.formValid = true : this.formValid = false
        },

        // Captura familiar al seleccionarlo del item para mostrarlo en el formulario
        capturarFamiliares(item) {
            this.infoFamiliar = false
            if (item.length !== 0) {
                if (item.length > this.familiar.length) {
                    this.showSnack({
                        message: 'No se puede insertar hijo, presione en agregar hijo primero',
                        type: '400'
                    });
                    this.familiarSeleccionado = [];
                    return;
                }
                if (item.length > 0) {
                    // Asigna los datos solo si hay suficiente espacio en el array `hijos`
                    item.forEach((familiar, index) => {
                        if (index < this.familiar.length) {
                            // Actualiza solo los objetos ya existentes en `this.hijos`
                            this.$set(this.familiar, index, {
                                ...this.familiar[index],
                                pnh_nombre: familiar.nombres,
                                pnh_apellido: familiar.apellido,
                                pnh_fechaNac: this.afiliado.pnc_fechaNac,
                                pnh_tipodoc: '1',
                                pnh_nroDoc: familiar.nrodoc,
                                pnh_sexo: familiar.sexo
                            });

                            // Actualiza también los datos de `familiarOriginal`
                            this.$set(this.familiarOriginal, index, {
                                ...this.familiarOriginal[index],
                                nacionalidad: familiar.nacionalidad, // Actualiza la nacionalidad
                                tipnacionalidad: familiar.tipnacionalidad, // Actualiza el tipo de nacionalidad
                            });
                        }
                        // Actualiza el `id` y `accion` en el array `familiarOriginal` en la misma posición
                        /*
                        if (index < this.familiarOriginal.length) {
                            this.$set(this.familiarOriginal, index, {
                                ...this.familiarOriginal[index],
                                    id: familiar.id, // Copia el id del familiar seleccionado
                                    accion: 'M'      // Cambia el valor de accion a 'M'
                                });
                        } */
                    });
                } else {
                    // Si no hay ningún familiar seleccionado, limpia el array `hijos`
                    this.familiar = [];
                }
            } else {
                this.familiar = [
                    {
                        pnh_nombre: '',
                        pnh_apellido: '',
                        pnh_sexo: '',
                        pnh_fechaNac: '',
                        pnh_tipodoc: '1',
                        pnh_nroDoc: '',
                    },
                ]
            }
        },
        async validarCbu() {
            this.loadBtnCuenta = true
            const resultado = await this.validarCBU({ cbu: this.afiliado.pnc_cbu })
            if (resultado) this.infoCuenta = true
            this.loadBtnCuenta = false; // Desactivamos el loading al finalizar

        },
        async validarSubsidio() {
            this.loadBtn = true
            const promises = this.familiar.map(familiar => {
                const obj = {
                    nroafi: this.nroafi,
                    tipoSubsidio: this.tipoSubsidio,
                    fechaNacimiento: this.afiliado.pnc_fechaNac,
                    dniFamiliar: familiar.pnh_nroDoc,
                    fechaSentencia: '',
                    fechaMatrimonio: ''
                };
                return this.validarSubsidioAfiliado(obj);
            });

            const results = await Promise.all(promises);
            this.loadBtn = false;

            if (!results.every(result => result === true)) {
                this.$refs.dialogoCom.abrirDialog()
            } else {
                this.infoFamiliar = true
                if (this.user.sexo == "F") {
                    this.mostrarMensaje = true
                }
            }
            this.loadBtn = false
        },

        /*         capturarFamiliares(item) {
                    if (item) {
                        this.hijos[0].pnh_nombre = item.nombres
                        this.hijos[0].pnh_apellido = item.apellido
                        this.hijos[0].pnh_fechaNac = item.fecnacim
                        this.hijos[0].pnh_nroDoc = item.nrodoc
                        this.hijos[0].pnh_sexo = item.sexo
                    }
        
                },
                capturarCuenta(item) {
                    this.afiliado.pnc_cbu = item.deb_cbucompleto
                    this.afiliado.pnc_nomYApeTitular = item.deb_tit_nombre
                    this.afiliado.pnc_cuit = this.user.cuil
                }, */

        capturarCuenta(item) {
            this.infoCuenta = false
            if (item) {
                this.afiliado.pnc_cbu = `${item.deb_cbu1}${item.deb_cbu2}`
                //  this.validarCBU({ cbu: this.afiliado.pad_cbu })
                this.afiliado.pnc_nomYApeTitular = this.nombreApellido
                this.afiliado.pnc_cuit = this.user.cuil
                this.selectedBancoCod = this.codigoBanco
            } else {
                this.afiliado.pnc_cbu = ''
                this.afiliado.pnc_nomYApeTitular = this.nombreApellido
                this.afiliado.pnc_cuit = ''
                this.selectedBancoCod = ''
            }
        },

        formatDate(date) {
            if (!date) return null
            if (date.includes('/')) {
                const [year, month, day] = date.split('/')
                return `${day}-${month}-${year}`
            } else {
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }
        },

        obtenerFamiliarOrdenado() {
            return this.familiarOriginal.map(familiar => {
                const familiarOrdenado = {};
                this.ordenClaves.forEach(key => {
                    familiarOrdenado[key] = familiar[key];
                });
                return familiarOrdenado;
            });
        },

        handlePaste(e) {
            e.preventDefault();
            this.showSnack({
                message: 'No esta permitido copiar y pegar',
                type: '500'
            })
        },
        async iniciarTramite() {
            try {
                this.loading = true
                // await this.validarSubsidio()
                this.familiarOriginal = this.familiarOriginal.map((familiarObj, index) => {
                    if (familiarObj.accion == 'A') {
                        // Obtiene los datos de afiliado y familiar (index usado para recorrer familiar)
                        return {
                            id: 0,
                            //nroafi: this.afiliado?.pnh_nroafi || "",
                            nroafi: this.nroafi || "",
                            apellido: this.familiar[index]?.pnh_apellido || "",
                            nombres: this.familiar[index]?.pnh_nombre || "",
                            sexo: this.familiar[index]?.pnh_sexo || "",
                            tipdoc: this.familiar[index]?.pnh_tipodoc || 1,
                            nrodoc: this.familiar[index]?.pnh_nroDoc || "",
                            estadocivil: "",
                            nacionalidad: familiarObj.nacionalidad || "",
                            tipnacionalidad: familiarObj.tipnacionalidad || "",
                            tipfamiliar: 3,
                            fecnacim: this.afiliado.pnc_fechaNac || "",
                            fecfallecido: "", // Dejar vacío si no se asigna un valor específico
                            fecestadocivil: "", // Asegura que esté vacío
                            discapacidad: "N", // Dejar vacío si no se asigna un valor específico
                            accion: "A"
                        };
                    }


                    // Retorna el objeto original si no cumple con accion === 'A'
                    return familiarObj;
                });
                //Si el conyuge/conviviente es nuevo seteo el familiar con id: 0 y las claves correspondientes para insertar
                console.log(this.familiarOriginal)
                const result = this.$refs.obs.validate()
                if (result) {
                    //this.copiarClaves()
                    const datosOrdenados = this.obtenerFamiliarOrdenado()
                    //const datosOrdenados = this.obtenerFamiliarOrdenado()
                    const formData = new FormData()
                    formData.append('afiliado', JSON.stringify(this.afiliado))
                    formData.append('familiar', JSON.stringify(this.familiar))
                    //familiarOriginal array de object
                    formData.append('familiarOriginal', JSON.stringify(datosOrdenados))

                    // Contador
                    let archIndex = 1

                    //Recorrer familiar
                    this.familiar.forEach((familiar, index) => {
                        if (this.partidaNacimiento[index]) {
                            formData.append(`archivo${archIndex}`, this.partidaNacimiento[index])
                            archIndex++
                        }
                    })
                    formData.append(`archivo${archIndex}`, this.comprobanteCbu[0])

                    formData.forEach((value, key) => {
                        console.log(`Campo: ${key}, Valor:`, value);
                    });
                    if (this.mostrarMensaje) {
                        await this.solicitarSubsidiosMaternidadNacimiento(formData)
                    } else {
                        await this.solicitarSubsidiosNacimiento(formData)
                    }
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            } catch (error) {
                console.error("Ocurrió un error durante el proceso:", error);
            } finally {
                this.loading = false
                this.$emit('handleDialog')
            }
        },
        iniciarbaTramite() {
            let vm = this
            this.$refs.obs.validate().then(result => {
                if (result) {
                    /* 
                    const formData = new FormData()
                    formData.append('afiliado', JSON.stringify([this.afiliado]))
                    formData.append('hijos', JSON.stringify(this.hijos))
                    formData.append('archivo1', this.sentenciaAdopcion[0])
                    formData.append('archivo2', this.comprobanteCbu[0])
                    
                    
                    const obj = {
                                    afiliado: [this.afiliado],
                                    hijos: this.hijos,
                                    archivo1: this.sentenciaAdopcion,
                                    archivo2: this.comprobanteCbu
                                } 
                                vm.solicitarSubsidiosNacimiento(formData)
                                */

                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        isObject(value) {
            return (
                typeof value == 'object' &&
                value !== null &&
                !Array.isArray(value)
            )
        },
        addHijo() {

            const obj = {
                pnh_nombre: '',
                pnh_apellido: '',
                pnh_sexo: '',
                pnh_fechaNac: this.afiliado.pnc_fechaNac,
                pnh_tipodoc: '1',
                pnh_nroDoc: '',
            }
            const objFamOrigin = {
                id: '',
                nroafi: "",
                nombres: "",
                apellido: '',
                sexo: "",
                tipdoc: 1,
                nrodoc: "",
                estadocivil: '',
                nacionalidad: '',
                tipnacionalidad: '',
                tipfamiliar: 3,
                fecnacim: "",
                fecfallecido: "",
                fecestadocivil: "",
                discapacidad: "",
                accion: "A"
            }
            this.familiar.push(obj)
            this.familiarOriginal.push(objFamOrigin)
        },
        eliminarHijo(index) {
            this.familiar.splice(index, 1)
            this.familiarOriginal.splice(index, 1)
        },
    },
    computed: {
        ...mapGetters('dataUser', ['sentenciaAdopcion', 'comprobanteCbu', 'partidaNacimiento']),
        ...mapGetters('subsidios', ['familiaresSubsidios', 'mediosPagos', 'necesitaNota']),
        ...mapGetters('auth', ['user', 'nroafi', 'isAuthenticated']),
        ...mapGetters('mediosDePago', ['bancos', 'codigoBanco']),
        ...mapGetters('common', ['tipoNacionalidad', 'estadoCivil', 'tiposFamiliares', 'nacionalidades']),

        nombreApellido() {
            return `${this.user.nombres} ${this.user.apellido}`
        }
    },
    props: {

    }

}
</script>

<style>
/* Aplicamos el estilo para ajustar el tamaño del texto */
.v-list-item__subtitle {
    white-space: normal;
}

.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para las acciones */
}

.custom-card-actions-ha {
    position: fixed;
    /* Fijo en la parte inferior */
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    /* Ajusta la altura según sea necesario */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    /* Asegúrate de que esté por encima del contenido */
}
</style>